import max from 'ml-array-max';
export function lookupPeak(data, options) {
    const { from, to } = options;
    let minIndex = data.x.findIndex((number) => number >= from);
    let maxIndex = data.x.findIndex((number) => number >= to) - 1;
    if (minIndex > maxIndex) {
        minIndex = maxIndex;
        maxIndex = minIndex;
    }
    const dataRange = data.re.slice(minIndex, maxIndex);
    if (dataRange && dataRange.length > 0) {
        const yValue = max(dataRange);
        const xIndex = dataRange.indexOf(yValue);
        const xValue = data.x[minIndex + xIndex];
        return { x: xValue, y: yValue, xIndex: minIndex + xIndex };
    }
    return null;
}
